export default "__VITE_ASSET__BPizeLNG__"